import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardContent, Typography } from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

const COLORS = ['#5E17EB', '#E0D7FA'];

export function AudienceRetentionChart({ data }) {
  return (
    <CustomCard>
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Nouveaux vs récurrents
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              innerRadius={60}
              outerRadius={90}
            >
              {data.map((_, index) => (
                <Cell key={index} fill={COLORS[index]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </CustomCard>
  );
}
